import React from 'react';

import { Checkbox } from '@components/common';

import { IOrganisationRoleInterface, TUserRoles } from '@enums/common';

import styles from './RolesSectio.module.scss';

interface IRolesSectionProps {
	category: IOrganisationRoleInterface;
	toggleRole: (name: TUserRoles) => void;
	roleAvailability?: Array<TUserRoles>;
}

const RolesSection = ({ category, toggleRole, roleAvailability }: IRolesSectionProps) => (
	<div className={styles.rolesSectionContainer}>
		<div className={styles.title}>
			{category.header}
		</div>
		<div className={styles.roles}>
			{category.roles.map(role => {
				const isChecked = roleAvailability?.includes(role.name);
				const onChangeRole = () => {
					toggleRole(role.name);
				};

				return (
					<Checkbox
						key={role.name}
						checked={isChecked}
						label={role.title}
						name={role.name}
						onChange={onChangeRole}
					/>
				);
			})}
		</div>
	</div>
);

export default RolesSection;
